<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('brands')">Brands</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />
          <text-input v-if="$can('repair-price')" v-model="form.percents" :optional="true" placeholder="valeur separé par virgule ex: 10,15,20" :error="errors.percents" class="pr-6 pb-8 w-full lg:w-1/2" label="Pourcentage(s)" />
          <text-input v-if="$can('repair-price')" v-model="form.amounts" :optional="true" placeholder="valeur separé par virgule ex: 100,200" :error="errors.amounts" class="pr-6 pb-8 w-full lg:w-1/2" label="Montant(s)" />
        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-end items-center">
          <loading-button :loading="sending" class="btn-indigo" type="submit">Create Brand</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo: { title: 'Create Brand' },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    errors: Object,
    shop: String,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        name: null,
        percents: null,
        amounts: null,
        shop: this.$page.props.auth.user.shopId,
      },
    }
  },
  methods: {
    submit() {
      const data = new FormData()
      data.append('name', this.form.name || '')
      data.append('percents', this.form.percents || '')
      data.append('amounts', this.form.amounts || '')
      data.append('shop', this.form.shop || '')

      this.$inertia.post(this.route('brands.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  },
}
</script>
